import * as types from '../constants';
import { GroupingState } from './state';
import { CHANGE_GROUPBY, COLLAPSE_GROUPBY, GroupingAction } from './types';

export const groupByInitialState = { key: types.GROUPBY_PRODUCTS } as GroupingState;

export function groupingReducer(grouping: GroupingState = groupByInitialState, action: GroupingAction): GroupingState {
    switch (action.type) {
        case CHANGE_GROUPBY:
            return { ...action.payload };

        case COLLAPSE_GROUPBY:
            return { ...grouping, ...{ id: null } };

        default:
            return grouping;
    }
}
